import React, { useRef, useEffect, createRef, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Card, CardBody, CardTitle, CardText } from "reactstrap";
import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import ArrowNext from "../../../images/arrow/luxury_next.png";
import Slider from "react-slick"
import styled from "styled-components"
import { getCloudImageUrl } from "../../../utils"

function FAQDetail({ item, subFaq, index, location, dataSection }) {
  const refArray = useRef([]);

  const PreviousArrow = (props) => {
    const { className, style, onClick } = props;
    const LeftArrow = styled.div`
      z-index: 1000;
      &::before {
        content: "" !important;
      }
      position: absolute;
      img {
        margin-left: 15px;
        width: 40px !important;
        height: 40px !important;
        object-fit: contain;
        box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
        border-radius: 30px;
        position: absolute;
      }
  
      @media (max-width: 480px) {
        z-index: 1;
        img {
          width: 30px !important;
          height: 30px !important;
          position: absolute;
          left: -5px;
        }
      }
    `;
    return (
      <LeftArrow
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <KickImage src={ArrowPrev} alt="..." />
      </LeftArrow>
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    const LeftArrow = styled.div`
      &::before {
        content: "" !important;
      }
      img {
        width: 40px !important;
        height: 40px !important;
        object-fit: contain;
        box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
        border-radius: 30px;
        right: 15px;
        position: absolute;
        z-index: 1000;
      }
  
      @media (max-width: 480px) {
        img {
          right: 10px;
          width: 30px !important;
          height: 30px !important;
        }
      }
    `;
    return (
      <LeftArrow
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <KickImage src={ArrowNext} alt="..." />
      </LeftArrow>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    prevArrow: <PreviousArrow />,
    nextArrow: <NextArrow />,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1
      }
    }]
  };

  const scrollToSection = (id) => {
    if (refArray.current[id]) {
      window.scrollTo({
        top: refArray.current[id].getBoundingClientRect().top - 170,
        behavior: "smooth"
      });
    }
  };

  useEffect(() => {
    dataSection && scrollToSection(dataSection)
  }, [dataSection])

  if (!item.answer) {
    return (
      <div
        ref={(ref) => {
          return refArray.current[index] = ref;
        }}
        className="detail-block">
        <Card>
          <CardBody>
            <CardTitle>{item.question}</CardTitle>
            <Slider {...settings}>
              {
                item.images && item.images.map((item, index) => (
                  <KickImage onLoad={() => window.dispatchEvent(new Event('resize'))}
                    style={{ height: window.screen.availWidth < 480 ? "150px" : "450px", objectFit: "contain" }} src={item.URL} alt={item.URL} />
                ))
              }
            </Slider>
          </CardBody>
        </Card>
      </div>
    )
  }

  return (
    <div
      key={item.id} ref={(ref) => {
        return refArray.current[index] = ref;
      }}>
      <Card>
        <CardBody>
          <CardTitle>{item.question}</CardTitle>
          <CardText>
            {
              item.answer &&
              <div className="item-answer" dangerouslySetInnerHTML={{ __html: item.answer }}></div>

            }
            {
              item.images && item.images.map((image, index) => {
                return <KickImage style={{ maxWidth: window.screen.availWidth > 480 ? "500px" : "300px", objectFit: "contain", margin: "auto", display: "block" }} src={image.URL} alt={image.URL} />
              })
            }
          </CardText>
        </CardBody>
      </Card>
    </div>
  )
}

export default FAQDetail
